import _ from 'lodash';

/**
 * Tracks a page view in various analytics integrations.
 * @param pageTitle {string}
 * @param opts {TrackingProviderOpts}
 */
export const trackPageView = (pageTitle, opts) => {
  /* Google Analytics */
  if (opts.ga) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageview',
      pageURL: window.location.href,
      pageTitle,
    });
  }

  /* Segment */
  if (opts.segment) {
    _.invoke(window, 'analytics.page');
  }
};

/**
 * Page view tracking options.
 * @typedef {Object} TrackingProviderOpts
 * @property {boolean=} ga
 * @property {boolean=} segment
 */
